<template>
  <section class="section white-panel mb2p pt20 pb28">
    <h2 class="fs16 mt4 mb4">車検実施店舗</h2>
    <table class="table w100p fs14 line-height1_2">
      <tbody>
        <tr>
          <th class="font-weight-normal color-font2 va-top pt8 w25p">店舗名</th>
          <td class="va-top pt8 pl8">{{ ssInfo.ss_name }}</td>
        </tr>
        <tr>
          <th class="font-weight-normal color-font2 va-top pt8">住所</th>
          <td class="va-top pt8 pl8">{{ ssInfo.address }}</td>
        </tr>
        <tr>
          <th class="font-weight-normal color-font2 va-top pt8">電話番号</th>
          <td class="va-top pt8 pl8"><a v-on:click="calling()" v-bind:class="{'color-green2':detail[0].status_code === 1}" >{{ ssInfo.tel }}</a></td>
        </tr>
        <tr v-if="ssInfo.opening_hours_weekday || ssInfo.opening_hours_saturday || ssInfo.opening_hours_sunday || ssInfo.opening_hours_holiday">
          <th class="font-weight-normal color-font2 va-top pt8">営業時間</th>
          <td class="va-top pt8 pl8">
            <template v-if="ssInfo.opening_hours_weekday">平日 {{ ssInfo.opening_hours_weekday }}<br></template>
            <template v-if="ssInfo.opening_hours_saturday">土曜 {{ ssInfo.opening_hours_saturday }}<br></template>
            <template v-if="ssInfo.opening_hours_sunday">日曜 {{ ssInfo.opening_hours_sunday }}<br></template>
            <template v-if="ssInfo.opening_hours_holiday">祝日 {{ ssInfo.opening_hours_holiday }}</template></td>
        </tr>
        <tr v-if="ssInfo.opening_hours_carcare">
          <th class="font-weight-normal color-font2 va-top pt8">カーケア<br>営業時間</th>
          <td class="va-top pt8 pl8">{{ ssInfo.opening_hours_carcare }}</td>
        </tr>
        <tr v-if="ssInfo.regular_holiday">
          <th class="font-weight-normal color-font2 va-top pt8">定休日</th>
          <td class="va-top pt8 pl8">{{ ssInfo.regular_holiday }}</td>
        </tr>
        <tr>
          <th class="font-weight-normal color-font2 va-top pt8">整備工場</th>
          <td v-if="ssInfo.factory_type_flag === 2" class="va-top pt8 pl8">{{ssInfo.factory_type_name}}工場</td>
          <td v-else-if="ssInfo.factory_type_flag === 3" class="va-top pt8 pl8">{{ssInfo.factory_type_name}}工場</td>
          <td v-else-if="ssInfo.factory_type_flag === 4" class="va-top pt8 pl8">提携工場で整備いたします。詳細は店舗へご確認ください。</td>
        </tr>
      </tbody>
    </table>
    <p class="text-center mt28 mb0">
      <a v-on:click.stop.prevent="inspectionDetailPage(tsId, ssInfo, profileInfo, nativeData, versionData)">
        <a href="#" target="_blank"><img src="/lib/images/banner_details_car_inspection.svg" class="w100p radius8" alt="アプリで簡単お見積り 業界初！コミコミ車検 整備費用も含めたコミコミ価格 充実のアフターケアと安心の整備基準 見積りから決済までアプリで完了"></a>
      </a>
    </p>
  </section>
</template>

<script>
import { useTsIdStore } from '@/store/tsId'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

export default {
  data () {
    return {
    }
  },
  methods: {
    calling () {
      this.nativeEVENTSet('CarCareButton', 'TEL_BUTTON', 'TAP')
      window.location.href = 'tel:' + this.ssInfo.tel
    },
    inspectionDetailPage (tsId, ssInfo, profileInfo, nativeData, versionData) {
      const tsIdStore = useTsIdStore()
      tsIdStore.tsId = tsId
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.$router.push({ name: 'InspectionDetailV3' })
    }
  },
  props: [
    'detail',
    'ssInfo',
    'tsId',
    'profileInfo',
    'nativeData',
    'versionData'
  ]
}
</script>
